<template>
  <q-card>
    <template v-if="modelData">
      <q-card-media v-if="imageField">
        <grid-cell-image :col="imageField" :value="modelData[imageField.field]">
          <div
            slot-scope="props"
          >
            <q-parallax :src="props.src" :height="250" :speed="0.2">
              <div slot="loading">Loading...</div>
            </q-parallax>
          </div>
        </grid-cell-image>
        <q-card-title slot="overlay">
          {{ modelData | shvl(titleFieldPath) }}
          <span slot="subtitle" v-if="subTitleFieldPath">
              {{ modelData | shvl(subTitleFieldPath) }}
            </span>
          <!--
          <q-btn
            @click="$router.push(`${baseRoute}/edit/${modelData.id}`)"
            fab
            color="info"
            icon="edit"
            class="absolute"
            style="top: 0; right: 8px; transform: translateY(-70%);"
          />
          --->
        </q-card-title>
      </q-card-media>
      <q-card-title class="title relative-position" v-else>
          <span>
            {{ modelData | shvl(titleFieldPath) }}
          </span>
      </q-card-title>
      <q-card-main>
        <q-list no-border>
          <q-item
            v-for="column in cardFields"
            :key="column.field"
            class="q-body-1"
          >
            <q-item-side color="primary">
              {{ column.label }}
            </q-item-side>
            <q-item-main class="text-info" align="left">
              <component
                :is="column | componentIs"
                class="text-info"
                :column="column"
                :value="modelData[column.field]"
                template="raw"
                :resource="resource"
                :row="modelData"
                :id="modelData.id"
              >
              </component>
            </q-item-main>
          </q-item>
        </q-list>
      </q-card-main>
      <q-card-separator/>
      <slot name="actions" :model-data="modelData" :base-route="baseRoute">
        <q-card-actions align="between">
          <q-btn
            @click="$router.push(`${baseRoute}/edit/${modelData.id}`)"
            color="primary"
            flat
            label="edit"
            icon="edit"
          />
          <q-btn flat small color="negative" icon="delete" @click="handleDelete(modelData.id)"></q-btn>
        </q-card-actions>
      </slot>
    </template>
    <q-inner-loading :visible="loading"></q-inner-loading>
  </q-card>
</template>
<script>
export default {
  name: 'ModelCardView',
  props: {
    model: {
      type: Object,
      required: true
    },
    resource: {
      type: String,
      default: () => this.$route.meta.resource
    }
  },
  data () {
    return {
      loading: false,
      modelData: null
    }
  },
  computed: {
    subTitleFieldPath () {
      const field = this.columns.find(col => col.hasOwnProperty('subtitle'))
      if (field.relation && field.relation.label) {
        return `${field.field}.${field.relation.label}`
      }
      return field.label
    },
    baseRoute () {
      return this.$store.state[this.resource].clientRoute
    },
    columns () {
      return this.$store.getters[`${this.resource}/columns`]
    },
    titleField () {
      return this.columns.find(col => col.isTitle)
    },
    titleFieldPath () {
      const field = this.titleField
      if (field) {
        if (field.relation && field.relation.label) {
          return `${field.field}.${field.relation.label}`
        }
        return field.field
      }
      return null
    },
    cardFields () {
      return this.$store.getters[`${this.resource}/visibleColumns`]
        .filter(col => {
          return !(col.isTitle || col.subtitle || col.type === 'image' || col.type === 'action')
        })
    },
    imageField () {
      return this.columns.find(col => col.type && col.type === 'image')
    }
  },
  async created () {
    try {
      this.loading = true
      const modelData = await this.$store.dispatch(`${this.resource}/fetchOne`, {
        client: this.$axios,
        id: this.model.id
      })
      this.$set(this, 'modelData', modelData)
      this.loading = false
    } catch (e) {
      this.loading = false
    }
  }
}
</script>
